export interface PasswordValidationResult {
  valid: boolean;
  errors: string[];
}

export interface PasswordRule {
  /** Schlüssel des Validierungsfehlers (z. B. für PasswordHint). Mehrere Regeln dürfen sich einen Key teilen. */
  key: string;
  /** Gibt true zurück, wenn die Regel erfüllt ist. */
  test: (value: string) => boolean;
  /** Anzuzeigende Fehlermeldung, wenn die Regel verletzt ist. */
  message: string;
}

const SPECIAL_CHAR_REGEX = /[~_+;!@#$%^&*(),.?":{}|<>[\]\\/]/;

/**
 * Einzige Quelle der Wahrheit für die Passwortregeln. Wird sowohl vom reaktiven
 * passwordValidator (Error-Keys) als auch von validatePasswordRules (Meldungstexte) genutzt.
 */
export const PASSWORD_RULES: PasswordRule[] = [
  {
    key: 'minlength',
    test: value => value.length >= 14,
    message: 'Das Passwort muss mindestens 14 Zeichen lang sein.'
  },
  {
    key: 'case',
    test: value => /[a-z]/.test(value),
    message: 'Das Passwort muss mindestens einen Kleinbuchstaben enthalten.'
  },
  {
    key: 'case',
    test: value => /[A-Z]/.test(value),
    message: 'Das Passwort muss mindestens einen Großbuchstaben enthalten.'
  },
  {
    key: 'number',
    test: value => /\d/.test(value),
    message: 'Das Passwort muss mindestens eine Zahl enthalten.'
  },
  {
    key: 'specialChar',
    test: value => SPECIAL_CHAR_REGEX.test(value),
    message: 'Das Passwort muss mindestens ein Sonderzeichen enthalten.'
  }
];

export function validatePasswordRules(value: string | null | undefined): PasswordValidationResult {
  // Prüft, ob das Passwort gesetzt ist
  if (!value || value.trim() === '') {
    return { valid: false, errors: ['Das Passwort darf nicht leer sein'] };
  }

  const errors = PASSWORD_RULES.filter(rule => !rule.test(value)).map(rule => rule.message);

  return { valid: errors.length === 0, errors };
}
